
export const addCustomFieldMetaData = (detailTypeId: number | undefined, values: any, accessor: string, setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void, isBoolean = false, displayName?: string | undefined) => {
    if (detailTypeId) {
        const fieldParentAccessor = accessor.slice(0, accessor.lastIndexOf('.'));
        const fieldDetailTypeIdAccessor = `${fieldParentAccessor}.detailTypeId`;
        const fieldIsBooleanAccessor = `${fieldParentAccessor}.isBoolean`;
        const fieldIdAccessor = `${fieldParentAccessor}.id`;
        const fieldSettingDataIdAccessor = `${fieldParentAccessor}.settingDataId`;
        const fieldDisplayName = `${fieldParentAccessor}.displayName`;

        if (!fieldParentAccessor.split('.').reduce((previous, current) => previous?.[current], values)) {
            setFieldValue(fieldDetailTypeIdAccessor, detailTypeId);
            setFieldValue(fieldIsBooleanAccessor, isBoolean);
            setFieldValue(fieldIdAccessor, '');
            setFieldValue(fieldSettingDataIdAccessor, '');
            if (displayName) {
                setFieldValue(fieldDisplayName, displayName)
            }
        }
    }
}

export const resetEnrollformValues = (obj) => {
    const transformedObj = {};
    for (const key in obj) {
        if (key === "custom") {
            for (const customkey in obj[key]) {
                obj[key][customkey].value = "";
            }
            transformedObj[key] = obj[key];
        } else if (typeof obj[key] === "string") {
            transformedObj[key] = " ";
        } else if (typeof obj[key] === "number") {
            transformedObj[key] = null;
        } else if (Array.isArray(obj[key])) {
            transformedObj[key] = [];
        } else {
            transformedObj[key] = obj[key];
        }
    }
    return transformedObj;
};